import React from "react";

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { ThemeProvider, createTheme } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";

import './App.css';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Product from "./views/Product";
import Landing from "./views/Landing";
import Confirmation from "./views/Confirmation";
import Admin from "./views/Admin";
import Products from "./views/Products";

const apptheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    primary: {
      main: "#111111",
    }
  },
});

const queryClient = new QueryClient();
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY!);

const App = () => {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={apptheme}>
          <Elements stripe={stripePromise}>
          <>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/products/:slug" element={<Product />} />
              <Route path="/products" element={<Products />} />
              <Route path="/confirmation/:secret" element={<Confirmation />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/orders" element={<Admin />} />
              <Route path="/admin/products" element={<Admin />} />
              <Route path="/admin/email-list" element={<Admin />} />
              <Route path="/admin/notify-subscribers" element={<Admin />} />
            </Routes>
          </>
          </Elements>
        </ThemeProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
